import { Link } from 'react-router-dom';
import { productCategories } from '@/mocks/categories';

const footerColumns = [
  {
    title: 'Product Categories',
    links: productCategories.slice(0, 7).map((cat) => ({
      label: cat.name,
      url: cat.url,
      external: true,
    })),
  },
  {
    title: 'More Categories',
    links: productCategories.slice(7).map((cat) => ({
      label: cat.name,
      url: cat.url,
      external: true,
    })),
  },
  {
    title: 'SEO Guides',
    links: [
      { label: 'How to Use Spreadsheet', url: '/article/how-to-use-allchinabuy-spreadsheet', external: false },
      { label: 'Safety & Review Guide', url: '/article/allchinabuy-spreadsheet-safety-guide', external: false },
      { label: 'Best Trusted Sellers', url: '/article/best-allchinabuy-spreadsheet-sellers', external: false },
      { label: 'AllChinaBuy Yupoo Guide', url: '/article/allchinabuy-yupoo-spreadsheet-guide', external: false },
    ],
  },
  {
    title: 'Quick Links',
    links: [
      { label: 'Home', url: '/', external: false },
      { label: 'Main Site', url: 'https://kaspreadsheet.com', external: true },
      { label: 'allchinabuy sheet', url: 'https://kaspreadsheet.com', external: true },
      { label: 'buy it now', url: 'https://kaspreadsheet.com', external: true },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/70 pt-16 pb-8 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading font-semibold text-sm text-foreground-950 mb-4">
                {column.title}
              </h4>
              <div className="w-8 h-px bg-background-300 mb-4"></div>
              <ul className="space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    {link.external ? (
                      <a
                        href={link.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.url}
                        className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-300/60 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-baseline gap-2">
            <span className="font-heading font-bold text-xl text-foreground-950">AllChinaBuy</span>
            <span className="font-heading text-xl text-foreground-400 font-light">Sheet</span>
          </div>

          <div className="flex items-center gap-4 text-foreground-400">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-foreground-600 transition-colors cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-global-line text-lg"></i>
              </div>
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-foreground-600 transition-colors cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-twitter-x-line text-lg"></i>
              </div>
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-foreground-600 transition-colors cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-reddit-line text-lg"></i>
              </div>
            </a>
          </div>

          <p className="text-xs text-foreground-400">
            &copy; 2026 AllChinaBuy Spreadsheet. For educational purposes only.
          </p>
        </div>

        <div className="mt-4 text-center">
          <p className="text-xs text-foreground-400">
            Reviewed by Shopping Experts &bull; Updated June 2026 &bull; 1000+ Products &bull; 500+ Sellers
          </p>
        </div>
      </div>
    </footer>
  );
}